export const museumsAToI = {
  ABBEY_MUSEUM: {
    key: 'ABBEY_MUSEUM',
    name: 'Abbey Museum',
    city: 'Caboolture',
    country: 'AU',
    url: 'https://abbeymuseum.com.au',
  },
  ADANA_ARKEOLOJI_MUZESI: {
    key: 'ADANA_ARKEOLOJI_MUZESI',
    name: 'Adana Arkeoloji Müzesi',
    city: 'Adana',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=AAR01&DistId=MRK',
  },
  ANCIENT_CULTURES_CHICAGO: {
    key: 'ANCIENT_CULTURES_CHICAGO',
    name: 'Institute for the Study of Ancient Cultures, West Asia & North Africa',
    city: 'Chicago',
    country: 'US',
    url: 'https://isac.uchicago.edu/',
  },
  ARCHAEOLOGISCHE_STAATSSAMMLUNG: {
    key: 'ARCHAEOLOGISCHE_STAATSSAMMLUNG',
    name: 'Archäologische Staatssammlung',
    city: 'Munich',
    country: 'DE',
    url: 'https://www.archaeologie.bayern/',
  },
  ASHMOLEAN_MUSEUM: {
    key: 'ASHMOLEAN_MUSEUM',
    name: 'Ashmolean Museum',
    city: 'Oxford',
    country: 'GB',
    url: 'https://ashmolean.org/',
  },
  AUSTRALIAN_INSTITUTE_OF_ARCHAEOLOGY: {
    key: 'AUSTRALIAN_INSTITUTE_OF_ARCHAEOLOGY',
    name: 'Australian Institute of Archaeology',
    city: 'Melbourne',
    country: 'AU',
    url: 'https://www.aiarch.org.au/',
  },
  BANQUE_NATIONALE_DE_BELGIQUE: {
    key: 'BANQUE_NATIONALE_DE_BELGIQUE',
    name: 'Banque Nationale de Belgique',
    city: 'Brussels',
    country: 'BE',
    url: 'https://www.nbb.be/',
  },
  BATMAN_HASANKEYF_MUZESI: {
    key: 'BATMAN_HASANKEYF_MUZESI',
    name: 'Batman Hasankeyf Müzesi',
    city: 'Batman',
    country: 'TR',
    url: 'https://kvmgm.ktb.gov.tr/TR-281298/batman-muze-mudurlugu.html',
  },
  BAYERISCHE_STAATSBIBLIOTHEK: {
    key: 'BAYERISCHE_STAATSBIBLIOTHEK',
    name: 'Bayerische Staatsbibliothek',
    city: 'Munich',
    country: 'DE',
    url: 'https://www.bsb-muenchen.de/',
  },
  BRYN_MAWR_COLLEGE: {
    key: 'BRYN_MAWR_COLLEGE',
    name: 'Bryn Mawr College Special Collections',
    city: 'Bryn Mawr',
    country: 'US',
    url: 'https://www.brynmawr.edu/about-college/special-collections',
  },
  CHESTER_BEATTY_LIBRARY: {
    key: 'CHESTER_BEATTY_LIBRARY',
    name: 'Chester Beatty Library',
    city: 'Dublin',
    country: 'IE',
    url: 'https://chesterbeatty.ie/',
  },
  COLUMBIA_UNIVERSITY: {
    key: 'COLUMBIA_UNIVERSITY',
    name: 'Columbia University Cuneiform Collection',
    city: 'New York',
    country: 'US',
    url: 'https://library.columbia.edu/libraries/rbml.html',
  },
  COUVENT_SAINTE_ANNE: {
    key: 'COUVENT_SAINTE_ANNE',
    name: 'Couvent Sainte-Anne',
    city: 'Jerusalem',
    country: 'IL',
    url: 'https://ste-anne-jerusalem.org/',
  },
  COUVENT_SAINT_ETIENNE: {
    key: 'COUVENT_SAINT_ETIENNE',
    name: 'Couvent Saint-Étienne',
    city: 'Jerusalem',
    country: 'IL',
    url: 'https://www.ebaf.edu/couvent/',
  },
  DE_LIAGRE_BOEHL_COLLECTION: {
    key: 'DE_LIAGRE_BOEHL_COLLECTION',
    name: 'de Liagre Böhl Collection',
    city: 'Leiden',
    country: 'NL',
    url: 'https://www.nino-leiden.nl/collections/de-liagre-bohl-collection',
  },
  DEUTSCHES_MUSEUM: {
    key: 'DEUTSCHES_MUSEUM',
    name: 'Deutsches Museum',
    city: 'Munich',
    country: 'DE',
    url: 'https://www.deutsches-museum.de/',
  },
  ECOLE_PRATIQUE_DES_HAUTES_ETUDES: {
    key: 'ECOLE_PRATIQUE_DES_HAUTES_ETUDES',
    name: 'École pratique des hautes Études',
    city: 'Paris',
    country: 'FR',
    url: 'https://www.ephe.psl.eu/',
  },
  ERIMTAN_MUSEUM: {
    key: 'ERIMTAN_MUSEUM',
    name: 'Erimtan Museum',
    city: 'Ankara',
    country: 'TR',
    url: 'https://erimtanmuseum.org/',
  },
  GAZIANTEP_MUSEUM: {
    key: 'GAZIANTEP_MUSEUM',
    name: 'Gaziantep Museum',
    city: 'Gaziantep',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=GZA01&DistId=MRK',
  },
  HARVARD_ART_MUSEUMS: {
    key: 'HARVARD_ART_MUSEUMS',
    name: 'Harvard Art Museums',
    city: 'Cambridge',
    country: 'US',
    url: 'https://harvardartmuseums.org/',
  },
  HARVARD_MUSEUM: {
    key: 'HARVARD_MUSEUM',
    name: 'Harvard Museum of the Ancient Near East',
    city: 'Cambridge',
    country: 'US',
    url: 'https://hmane.harvard.edu/',
  },
  HARVEY_CUSHING_WHITNEY_MEDICAL_LIBRARY: {
    key: 'HARVEY_CUSHING_WHITNEY_MEDICAL_LIBRARY',
    name: 'Harvey Cushing/John Hay Whitney Medical Library, Yale University',
    city: 'New Haven',
    country: 'US',
    url: 'https://library.medicine.yale.edu/',
  },
  HATAY_ARCHAEOLOGY_MUSEUM: {
    key: 'HATAY_ARCHAEOLOGY_MUSEUM',
    name: 'Hatay Archaeology Museum',
    city: 'Antakya',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=HTY01&DistId=HTY',
  },
  HEARST_MUSEUM: {
    key: 'HEARST_MUSEUM',
    name: 'Phoebe A. Hearst Museum of Anthropology',
    city: 'Berkeley',
    country: 'US',
    url: 'https://hearstmuseum.berkeley.edu/',
  },
  HERMITAGE: {
    key: 'HERMITAGE',
    name: 'The State Hermitage Museum',
    city: 'Saint Petersburg',
    country: 'RU',
    url: 'https://www.hermitagemuseum.org/',
  },
  HILPRECHT_COLLECTION: {
    key: 'HILPRECHT_COLLECTION',
    name: 'Frau Professor Hilprecht Collection of Babylonian Antiquities',
    city: 'Jena',
    country: 'DE',
    url: 'https://www.gw.uni-jena.de/fakultaet/institut-fuer-orientalistik-indogermanistik-ur-und-fruehgeschichtliche-archaeologie/altorientalistik/hilprecht-sammlung',
  },
  HYPERURANION: { key: 'HYPERURANION', name: '', city: '', country: '' },
  ISTANBUL_ARKEOLOJI_MUSEUM: {
    key: 'ISTANBUL_ARKEOLOJI_MUSEUM',
    name: 'İstanbul Arkeoloji Müzeleri',
    city: 'Istanbul',
    country: 'TR',
    url: 'https://muze.gov.tr/muze-detay?SectionId=IAR01&DistId=IAR',
  },
  IZIKO_MUSEUMS_OF_SOUTH_AFRICA: {
    key: 'IZIKO_MUSEUMS_OF_SOUTH_AFRICA',
    name: 'Iziko Museums of South Africa',
    city: 'Cape Town',
    country: 'ZA',
    url: 'https://www.iziko.org.za/',
  },
} as const
